import { MODAL_STEPS } from "../../../../../constants/modal";
import { useUserContext } from "../../../../../store/userContext";
import StepShoeQuestions from "../../StepShoeQuestions";

export interface ShoeStepsProps {
  step: {
    number: number;
  } | null;
  shoeQuestion: string | null;
  setShoeQuestion: React.Dispatch<React.SetStateAction<string | null>>;
  setStep: (step: any) => void;
  subtitlesStyles?: any;
  mock: boolean;
  domain: string | null;
  visionInit: (uid: string) => Promise<any>;
  sendQuestionAnswers?: () => void | Promise<void>;
}

const noop = () => {};

const ShoeSteps: React.FC<ShoeStepsProps> = ({
  step,
  shoeQuestion,
  setShoeQuestion,
  setStep,
  subtitlesStyles,
  mock,
  domain,
  visionInit,
  sendQuestionAnswers = noop,
}) => {
  const userContext = useUserContext();

  const handleNext = async () => {
    if (mock) {
      sendQuestionAnswers();
      setStep(MODAL_STEPS.RESULT);
      return;
    }

    if (!userContext) return;

    await userContext.createNewMeasure("question");

    let currentUid: string | null | undefined =
      localStorage.getItem("uid") ?? userContext.uid;

    if (!currentUid && domain) {
      currentUid = await userContext.createNewUser(domain);
    }

    if (currentUid) {
      const result = await visionInit(currentUid);
      if (result) sendQuestionAnswers();
    }
  };

  return (
    <>
      {step?.number === MODAL_STEPS.SHOE_QUESTIONS.number && (
        <StepShoeQuestions
          shoeQuestion={shoeQuestion}
          setShoeQuestion={setShoeQuestion}
          nextStep={async () => handleNext()}
          subtitlesStyles={subtitlesStyles}
        />
      )}
    </>
  );
};

export default ShoeSteps;
